import {
  HIRE_DETAILS,
  HIRE_DETAILS_FAILED,
  HIRE_DETAILS_SUCCESS,
  SAVE_HIRE_DETAILS,
  SAVE_HIRE_DETAILS_FAILED,
  SAVE_HIRE_DETAILS_SUCCESS,
} from "./actionTypes";
const initialState = {
  loader: false,
  hireDetails: null,
  hireError: null,
  success:null
};

const HireReducer = (state = initialState, action) => {
  switch (action.type) {
    case HIRE_DETAILS:
      state = {
        ...state,
        loader: true,
        hireDetails: null,
        hireError: null,
      };
      break;
    case HIRE_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        hireDetails: action.payload,
        hireError: null,
      };
      break;
    case HIRE_DETAILS_FAILED:
      state = {
        ...state,
        loader: false,
        hireDetails: null,
        hireError: action.payload,
      };
      break;
      case SAVE_HIRE_DETAILS:
              state={
                ...state,
                loader:true,
                success:null,
                hireError:null,
              }
            break   
            case SAVE_HIRE_DETAILS_SUCCESS:
              
              state={
                ...state,
                loader:false,
                success:action.payload,
                hireError:null,
              }
            break   
            case SAVE_HIRE_DETAILS_FAILED:
             
              state={
                ...state,
                loader:false,
                success:null,
                hireError:action.payload,
              }
            break  
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default HireReducer;
